module.exports = __webpack_public_path__ + "static/cr-announcement-hero-mobile-6f09b55441640d5b8a102f6f95646cae.png";